import { combineReducers } from "redux"

import { entitiesReducer } from "./entities"
import { listReducer } from "./list"

export default combineReducers({
  entities: entitiesReducer,
  list: listReducer,
})
